import { IconAlertTriangle, IconCheck, IconX } from "@tabler/icons-react";
import type { ReactNode } from "react";

export enum ErrorState {
  SUCCESS = "success",
  WARN = "warn",
  ERROR = "error",
}

export function getColorByState(key?: ErrorState) {
  const errorState = key ?? ErrorState.SUCCESS;
  const errorStateColorMap: Record<ErrorState, "zli-green" | "red" | "zli-orange"> = {
    [ErrorState.SUCCESS]: "zli-green",
    [ErrorState.WARN]: "zli-orange",
    [ErrorState.ERROR]: "red",
  };

  return errorStateColorMap[errorState];
}

export function getIconByState(key?: ErrorState) {
  const errorState = key ?? ErrorState.SUCCESS;
  const errorStateIconMap: Record<ErrorState, ReactNode> = {
    [ErrorState.SUCCESS]: <IconCheck size={20} />,
    [ErrorState.WARN]: <IconAlertTriangle size={20} />,
    [ErrorState.ERROR]: <IconX size={20} />,
  };

  return errorStateIconMap[errorState];
}
